if (!customElements.get('header-wrapper')) {
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();

      this.handleScrollRef = this.handleScroll.bind(this);
      this.setHeaderHeightRef = this.setHeaderHeight.bind(this);
      this.announcementBar = document.querySelector('announcement-bar');
    }

    handleScroll() {
      let announcementBarHeight = this.announcementBar?.querySelector('.announcement-bar').scrollHeight || 0;

      this.classList.toggle('header--scrolled', window.scrollY > announcementBarHeight);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', this.firstElementChild.clientHeight + 'px');
    }

    handleHoverState() {
      this.classList.toggle('header-wrapper--hover', this.matches(':hover'));

      this.announcementBar?.classList.toggle('announcement-bar--hover', this.matches(':hover'));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeightRef);
      this.removeEventListener('scroll', this.handleScrollRef, false);
    }

    connectedCallback() {
      this.setHeaderHeight();

      this.target = this.querySelector('.js-target');
      this.target.addEventListener('toggle', () => {
        this.classList.toggle('is-open', this.target.open)
      });

      window.addEventListener('resize', this.setHeaderHeightRef);

      if(this.getAttribute('data-is-transparent')) document.querySelector('main').classList.add('reduced-padding');

      if (!this.getAttribute('data-enable-scroll')) return;

      this.firstSection = document.querySelector('main .shopify-section:first-of-type');
      this.offset = this.firstSection ? this.firstSection.clientHeight : 0;
      document.addEventListener('scroll', this.handleScrollRef, false);
      this.addEventListener('mouseenter', this.handleHoverState.bind(this));
      this.addEventListener('mouseleave', this.handleHoverState.bind(this));
    }
  }
  customElements.define('header-wrapper', HeaderWrapper);
}
